import { render, staticRenderFns } from "./datosGenerales.vue?vue&type=template&id=d0d254ac&scoped=true&"
import script from "./datosGenerales.vue?vue&type=script&lang=js&"
export * from "./datosGenerales.vue?vue&type=script&lang=js&"
import style0 from "./datosGenerales.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./datosGenerales.vue?vue&type=style&index=1&id=d0d254ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d254ac",
  null
  
)

export default component.exports